<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Rough Tender</h2>
      <div>
        <button class="btn btn-primary" @click="create_tender_winning">
          New Winning
        </button>
        <button class="btn btn-primary ml-2" @click="open_tender_modal">
          New Tender
        </button>
      </div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-8">
      <div class="flex flex-wrap items-center justify-between">
        <div class="grid grid-cols-12 gap-x-2 w-full">
          <div class="col-span-6 md:col-span-3 xl:col-span-3">
            <div class="">
              <input
                type="text"
                id="update-profile-form-13"
                class="form-control"
                placeholder="Tender Name"
                v-model="filters.tender_name"
              />
            </div>
          </div>
          <div class="col-span-6 md:col-span-3 xl:col-span-3">
            <TomSelect
              v-model="filters.company_id"
              :options="{
                placeholder: 'Select Company',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Company'
                  }
                }
              }"
              class="w-full"
            >
              <option value="0">Select Company</option>
              <option
                v-for="(stone, index) in screenData.parties"
                :key="index"
                :value="stone.id"
                >{{ stone.firm_name }}
              </option>
            </TomSelect>
          </div>

          <div class="col-span-6 md:col-span-3 xl:col-span-3">
            <div>
              <Litepicker
                v-model="filters.tender_date"
                :options="{
                  singleMode: false,
                  autoApply: false,
                  format: 'YYYY-MM-DD',
                  showWeekNumbers: true,
                  dropdowns: {
                    minYear: 1990,
                    maxYear: null,
                    months: true,
                    years: true
                  },
                }"
                class="form-control pl-12"
              />
            </div>
          </div>
          <div class="col-span-2 md:col-span-2 xl:col-span-1">
            <div class="flex">
              <button
                id="tabulator-html-filter-reset"
                type="button"
                class="btn btn-secondary w-full mt-2 sm:mt-0 sm:ml-2"
                @click="onResetFilter"
              >
                Reset
              </button>
            </div>
          </div>
          <div class="col-span-2 md:col-span-2 xl:col-span-1">
            <div class="flex">
              <button
                id="tabulator-html-filter-go"
                type="button"
                class="btn btn-primary w-full ml-2"
                tabindex="5"
                @click="initTabulator()"
              >
                Go
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div id="tabulator" ref="tableRef" class="mt-5"></div>
      </div>
    </div>
  </div>

  <div id="success-notification-content" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">Details saved successfully!</div>
      <div class="text-gray-600 mt-1"></div>
    </div>
  </div>
  <!-- END: Success Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">Something went wrong!</div>
      <div class="text-gray-600 mt-1">
        Please check the fileld form.
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  onMounted,
  inject
} from 'vue'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import { useRouter, useRoute } from 'vue-router'
import { BASE_URL } from '@/constants/config.js'
    const router = useRouter()
    const tableRef = ref()
    const tabulator = ref()
    const pageData = reactive({
      errors: [],
      locationList: [],
      companyList: [],
      partnerList: [],
      colorList: [],
      brownList: [],
      tensionList: [],
      flowList: [],
      tensionList: [],
      purityList: [],
      blueUvList:Array.from({ length: 76 }, (_, i) => (i).toString().padStart(3, '0')),
      modelIndex: 0,
      modelFileType: '',
      submit: false,
      token: localStorage.getItem('token')
    })

    const swal = inject('$swal')

    const filters = reactive({
      company_id: '',
      tender_date: '',
      tender_name: ''
    })
    const screenData = reactive({
      transaction_no: '',
      issuer: '',
      status: '0',
      employee_type: '3',
      employee_id: '',
      process_id: '0',
      employees: [],
      process_items: [],
      parties: [],
      emp_hit: 1
    })

    function get_company_list() {
      axios({
        url: 'api/master/tender_company_list',
        method: 'post',
        baseURL: BASE_URL,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        config: {
          headers: {
            Accept: 'application/json'
          }
        }
      }).then(res => {
        pageData.companyList = res.data.items
      })
    }
    const open_tender_modal = () => {
      router.push('/tender/create')
      // cash('#new-rough-tender-modal').modal('show')
    }

    const create_tender_winning = () => {
      router.push('/tender/winning/create')
    }

    const cancel_tender = id => {
      const params = { id: btoa(id) }

      swal({
        title: 'Are you sure?',
        text: 'Do you want to change the status?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, cancel it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          axios({
            url: 'api/tender/cancel',
            method: 'post',
            baseURL: BASE_URL,
            data: params,
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token')
            },
            config: { headers: { Accept: 'application/json' } }
          })
            .then(res => {
              swal({
                text: res.data.msg,
                icon: 'success',
                buttonsStyling: false,
                confirmButtonText: 'Ok, got it!',
                heightAuto: false,
                customClass: {
                  confirmButton: 'btn btn-sm btn-primary btm-sm py-2'
                }
              })
              initTabulator()
            })
            .catch(error => {
              // Handle error if needed
            })
        }
      })
    }

    const initTabulator = () => {
      let params = {
        company_id: window.btoa(filters.company_id),
        tender_date: window.btoa(filters.tender_date),
        tender_name: window.btoa(filters.tender_name)
      }

      let _this = this
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxURL: BASE_URL + 'api/tender/index',
        ajaxConfig: {
          method: 'GET', //set request type to Position
          headers: {
            'Content-type': 'application/json; charset=utf-8', //set specific content type
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        },
        ajaxParams: params,
        ajaxFiltering: true,
        ajaxSorting: true,
        printAsHtml: true,
        printStyled: true,
        pagination: 'remote',
        paginationSize: 20,
        paginationSizeSelector: [20, 30, 40],
        layout: 'fitColumns',
        responsiveLayout: false,
        tooltipsHeader: true,
        headerSort: false,
        placeholder: 'No matching records found',
        columns: [
          // For HTML table
          {
            title: 'Tender Name',
            minWidth: 100,
            responsive: 0,
            field: 'tender_name',
            vertAlign: 'middle',
            print: false,
            download: true,

            formatter(cell) {
              const a = cash(`<div>
                            ${cell.getData().tender_name}
                            </div>`)
              cash(a).on('click', function() {
                view_details(cell.getData().id)
              })
              return a[0]
            }
          },
          {
            title: 'Company Name',
            minWidth: 100,
            field: 'company_id',
            hozAlign: 'left',
            vertAlign: 'middle',
            print: false,
            download: true,
            formatter(cell) {
              return cell.getData().tender_company?.firm_name ?? ""
            }
          },
          {
            title: 'Tender Date',
            minWidth: 100,
            field: 'tender_time',
            hozAlign: 'left',
            vertAlign: 'middle',
            print: false,
            download: true
          },
          {
            title: 'Tender Place',
            minWidth: 100,
            field: 'location',
            hozAlign: 'left',
            vertAlign: 'middle',
            print: false,
            download: true,
            formatter(cell) {
              return cell.getData().location?.location_name ?? ""
            }
          },
          {
            title: 'Total Lot',
            minWidth: 100,
            field: 'total_lots',
            hozAlign: 'left',
            vertAlign: 'middle',
            print: false,
            download: true
          },
          {
            title: 'Total Weight',
            minWidth: 100,
            field: 'total_weight',
            hozAlign: 'left',
            vertAlign: 'middle',
            print: false,
            download: true
          },
          {
            title: 'Total Amount',
            minWidth: 100,
            field: 'total_amount',
            hozAlign: 'left',
            vertAlign: 'middle',
            print: false,
            download: true
          },
          {
            title: 'Partner',
            minWidth: 100,
            field: 'partner',
            hozAlign: 'left',
            vertAlign: 'middle',
            print: false,
            download: true,
            formatter(cell) {
              return cell.getData().partner?.firm_name ?? ""
            }
          },
          {
            title: 'Declare Date',
            minWidth: 100,
            field: 'declare_time',
            hozAlign: 'left',
            vertAlign: 'middle',
            print: false,
            download: true
          },
          {
            title: 'Status',
            minWidth: 100,
            field: 'active_status',
            vertAlign: 'middle',
            print: false,
            download: false,

            formatter(cell) {
              return `<div class="flex lg:justify-center ${
                cell.getData().statusText == 'Cancelled'
                  ? 'text-theme-6': cell.getData().statusText == 'Won'?
                   'text-theme-1' : cell.getData().statusText == 'Active'? 'text-theme-9':'text-theme-6'
              }">
                             ${cell.getData().statusText}
                          </div>
                          `
            }
          },
          {
            title: 'Action',
            hozAlign: 'center',
            field: 'status',
            minWidth: 100,
            vertAlign: 'middle',
            print: false,
            responsive: 0,
            download: false,
            formatter(cell) {
              const dropdown = document.createElement('div')
              dropdown.classList.add('dropdown')

              const button = document.createElement('button')
              button.classList.add(
                'btn',
                'btn-secondary',
                'btn-sm',
                'dropdown-toggle'
              )
              button.setAttribute('id', 'dropdownMenuButton')
              button.setAttribute('type', 'button')
              button.setAttribute('data-toggle', 'dropdown')
              button.setAttribute('aria-haspopup', 'true')
              button.setAttribute('aria-expanded', 'false')
              button.innerText = 'Action'

              const menu_icon = document.createElement('i')
              menu_icon.classList.add('w-4', 'h-4', 'ml-2')
              menu_icon.setAttribute('data-feather', 'chevron-down')
              button.appendChild(menu_icon)

              const menu = document.createElement('div')
              menu.setAttribute('aria-labelledby', 'dropdownMenuButton')
              menu.classList.add('dropdown-menu')

              const sub_menue = document.createElement('div')
              sub_menue.classList.add(
                'dropdown-menu__content',
                'box',
                'bg-theme-26',
                'dark:bg-dark-6',
                'text-white'
              )

              //View
              const main_view_details = document.createElement('div')
              main_view_details.classList.add(
                'p-1',
                'border-t',
                'border-theme-27',
                'dark:border-dark-3'
              )
              const view_details = document.createElement('div')
              view_details.classList.add(
                'flex',
                'items-center',
                'block',
                'p-2',
                'transition',
                'duration-300',
                'ease-in-out',
                'rounded-md',
                'cursor-pointer',
                'hover:bg-theme-1',
                'dark:hover:bg-dark-3'
              )
              view_details.setAttribute('data-dismiss', 'dropdown')
              view_details.innerText = 'View Details'

              view_details.addEventListener('click', function handleClick(
                event
              ) {
                router.push('/tender/view/' + window.btoa(cell.getData().id))
              })
              main_view_details.appendChild(view_details)
              sub_menue.appendChild(main_view_details)


              //Cancel
              if((cell.getData().statusText == 'Active') || (cell.getData().statusText == 'Expired')) {
                // Edit
                const main_edit = document.createElement('div')
                main_edit.classList.add(
                  'p-1',
                  'border-t',
                  'border-theme-27',
                  'dark:border-dark-3'
                )
                const edit = document.createElement('div')
                edit.setAttribute('data-dismiss', 'dropdown')
                edit.classList.add(
                  'flex',
                  'items-center',
                  'block',
                  'p-2',
                  'transition',
                  'duration-300',
                  'ease-in-out',
                  'rounded-md',
                  'cursor-pointer',
                  'hover:bg-theme-1',
                  'dark:hover:bg-dark-3'
                )
                edit.innerText = 'Edit Details'

                edit.addEventListener('click', function handleClick(event) {
                  // get_tender_data(cell.getData().id)
                  router.push('/tender/update/' + window.btoa(cell.getData().id))
                  // get_tender_data(cell.getData().id)
                })
                main_edit.appendChild(edit)
                sub_menue.appendChild(main_edit)


                const main_reject_purchase = document.createElement('div')
                main_reject_purchase.classList.add(
                  'p-1',
                  'border-t',
                  'border-theme-27',
                  'dark:border-dark-3'
                )
                const reject_purchase = document.createElement('div')
                reject_purchase.setAttribute('data-dismiss', 'dropdown')
                reject_purchase.classList.add(
                  'flex',
                  'items-center',
                  'block',
                  'p-2',
                  'transition',
                  'duration-300',
                  'ease-in-out',
                  'rounded-md',
                  'cursor-pointer',
                  'hover:bg-theme-1',
                  'dark:hover:bg-dark-3'
                )
                reject_purchase.innerText = 'Cancel Tender'

                reject_purchase.addEventListener('click', function handleClick(
                  event
                ) {
                  cancel_tender(cell.getData().id)
                })
                main_reject_purchase.appendChild(reject_purchase)
                sub_menue.appendChild(main_reject_purchase)
              }

              menu.appendChild(sub_menue)
              dropdown.appendChild(button)
              dropdown.appendChild(menu)

              // const item2 = document.createElement("a");
              // item2.classList.add("dropdown-item");
              // item2.innerText = "Item 2";
              // menu.appendChild(item2);

              const b = cash(dropdown)
              return b[0]

              const a = cash(
                `<div style='display: flex'>
                                            <div class='dropdown'>
                                             <button class='btn btn-secondary dropdown-toggle' type='button' id='dropdownMenuButton' data-bs-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>Action</button>
                                             <div class='dropdown-menu' aria-labelledby='dropdownMenuButton'>
                                              <div class="dropdown-menu__content box bg-theme-26 dark:bg-dark-6 text-white">` +
                  (cell.getData().status == 0 &&
                  cell.getData().pr_status == null
                    ? `<div class='p-2 border-t border-theme-27 dark:border-dark-3'><button class="flex items-center p-2"><i data-feather="edit" class="w-4 h-4 mr-3"></i> Edit </button></div>`
                    : ``) +
                  (cell.getData().status == 0
                    ? `<div class='p-2 border-t border-theme-27 dark:border-dark-3'><button class="flex items-center p-1"><i data-feather="trash-2" class="w-4 h-4 mr-3"></i> Reject Purchase</button></div>`
                    : '') +
                  (cell.getData().status == 0
                    ? `<div class='p-2 border-t border-theme-27 dark:border-dark-3'><button class="flex items-center p-1"><i data-feather="pie-chart" class="w-4 h-4 mr-3"></i> Reject Pieces</button></div>`
                    : '') +
                  (cell.getData().status == 0
                    ? `<div class='p-2 border-t border-theme-27 dark:border-dark-3'><button class="flex items-center p-1"><i data-feather="chevrons-right" class="w-4 h-4 mr-3"></i> Issue</button></div>`
                    : '') +
                  (cell.getData().status == 0
                    ? `<div class='p-2 border-t border-theme-27 dark:border-dark-3'><button class="flex items-center p-1"><i data-feather="plus" class="w-4 h-4 mr-3"></i> New Pieces</button></div>`
                    : '') +
                  `<div class='p-2 border-t border-theme-27 dark:border-dark-3'><button class="flex items-center p-1"> View Details</button></div>` +
                  `</div>
                                              </div></div></div>`
              )
              cash(a).on('click', function() {
                // get_purchase_data(cell.getData().id)
              })
              return a[0]
            }
          }
          // {
          //   title: 'Print',
          //   minWidth: 100,
          //   width: 100,
          //   field: '',
          //   responsive: 1,
          //   hozAlign: 'center',
          //   vertAlign: 'middle',
          //   headerSort: false,
          //   print: false,
          //   download: false,
          //   formatter(cell) {
          //     const a = cash(`<div class="flex lg:justify-center items-center">
          //                     <button class="text-primary-1 p-1">
          //                       <i data-feather="printer" class="w-4 h-4 mr-1"></i>
          //                     </button>
          //                   </div>`)
          //     cash(a).on('click', function() {
          //       print_details(cell.getData().id)
          //     })
          //     return a[0]
          //   }
          // }
        ],
        renderComplete() {
          feather.replace({
            'stroke-width': 1.5
          })
        }
      })
    }
    function getParties() {
      axios({
        url: 'api/master/tender_company_list',
        method: 'post',
        baseURL: BASE_URL,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        config: {
          headers: {
            Accept: 'application/json'
          }
        }
      }).then(res => {
        screenData.parties = res.data.items
      })
    }

    const view_details = id => {
      router.push({
        path: '/tender/view/' + window.btoa(id)
      })
    }
    const onResetFilter = () => {
      filters.tender_name = ''
      // filters.start_date = moment()
      //   .startOf('month')
      //   .format('YYYY-MM-DD')
      // filters.end_date = moment().format('YYYY-MM-DD')
      filters.tender_date = ''
      filters.company_id = ''
      initTabulator()
    }

    onMounted(() => {
      initTabulator()
      getParties()
      get_company_list()
      onResetFilter()

    })
</script>
<style scoped>
a:link {
  text-decoration: underline;
}
.btn.btn-outline-primary.btn-xs.py-1:hover {
  background-color: transparent;
}
#new-rough-tender-modal {
  padding-left: 0 !important;
}
.modal-body-w {
  height: 100vh !important;
}
.overflow-auto {
  scrollbar-width: thin;
}
.overflow-x-auto {
  scrollbar-width: thin;
}

</style>
